// @ts-nocheck
import { makeVar } from '@apollo/client'
import { UserBlockchainBalance } from '__generated__/graphql'

const initialUserBlockChainBalance: UserBlockchainBalance = {
  walletAddress: '',
  nativeBalance: 0,
  tokenBalance: 0,
  tokenDeposited: 0,
  chainIdentifier: ''
}

export const balanceVar = makeVar<UserBlockchainBalance>(
  initialUserBlockChainBalance
)
